module.exports = __webpack_public_path__ + "img/pic2.6cb85c53.png";